<template>
  <router-view/>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

/* Element Plus 全局样式优化 */
:root {
  --el-color-primary: #667eea;
  --el-border-radius-base: 8px;
}

/* 表格样式优化 */
.el-table {
  --el-table-border-color: rgba(0, 0, 0, 0.06);
  --el-table-header-bg-color: rgba(102, 126, 234, 0.05);
  border-radius: 12px;
  overflow: hidden;
}

.el-table th.el-table__cell {
  background: rgba(102, 126, 234, 0.08);
  color: #333;
  font-weight: 600;
}

.el-table .el-table__cell {
  padding: 16px 0;
}

/* 按钮样式优化 */
.el-button {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s;
}

.el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.el-button--primary:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* 对话框样式优化 */
.el-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.el-dialog__header {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  padding: 20px;
  margin: 0;
}

.el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.el-dialog__body {
  padding: 24px;
}

/* 输入框样式优化 */
.el-input__wrapper {
  border-radius: 8px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1) inset;
  transition: all 0.3s;
}

.el-input__wrapper:hover {
  box-shadow: 0 0 0 1px rgba(102, 126, 234, 0.3) inset;
}

.el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px #667eea inset;
}

/* 标签样式优化 */
.el-tag {
  border-radius: 6px;
  padding: 4px 12px;
  font-weight: 500;
}

/* 消息提示样式优化 */
.el-message {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 加载动画优化 */
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(102, 126, 234, 0.3);
  border-radius: 4px;
  transition: all 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(102, 126, 234, 0.5);
}
</style>
